import React, { useRef, useState, useEffect, useMemo } from "react";
import {
    Grid,
    Box,
    TextField,
    CircularProgress,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
    Typography
} from "@mui/material";
import { message } from "antd";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fetchOiAnalyz, fetchOptionMapsByTradeDate, OptionBuyToken } from "../../utils/services";
import { getToken } from "../../utils/helpers";
import { API } from "../../utils/constant";
import MultiLineOIChart from "../../components/Chart/TradingView/TVChart";
import DynamicMACDCharts from "../../components/ChartComponent/MACDHistChart";
import { useWebSocket } from "../../hooks/useWebSocket";
import moment from "moment";
import { useAuthContext } from "../../context/AuthContext";
// Redux
import { useDispatch } from 'react-redux';
import { updateMultipleTokenPrices } from '../../redux/slices/marketDataSlice';


// import { updateMACDHistogram } from '../../redux/slices/marketDataSlice';
// import { bufferPriceUpdate } from "../../redux/utils/bufferUtils";
// MUI Icons for layout toggle
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import OptionBuyingTool from "./OptionBuyTool";

export const formatToUTCTimestamp = (datetime) => {
    if (!datetime) return null;
    return Math.floor(new Date(datetime).getTime() / 1000) + 19800; // Convert IST to UTC
};
const REFRESH_INTERVAL = 20 * 1000; // 20 seconds
const todayDate = new Date().toISOString().split("T")[0];

const formatValue = (value) => {
    if (value >= 1_00_00_000) {
        return (value / 1_00_00_000).toFixed(1) + "Cr";
    } else if (value >= 10_00_000) {
        return (value / 10_00_000).toFixed(1) + "M";
    } else if (value >= 1_00_000) {
        return (value / 1_00_000).toFixed(1) + "L";
    } else if (value >= 1000) {
        return (value / 1000).toFixed(1) + "K";
    }
    return value;
};

const TraderPageTV = () => {
    const { user } = useAuthContext();
    // --------------------- State Definitions --------------------- //
    const [token, setToken] = useState(26000);

    const [userStrategies, setUserStrategies] = useState([]);
    const [selectedDate, setselectedDate] = useState(() => {
        const localDate = new Date();
        const options = { timeZone: "Asia/Kolkata" };
        const istDate = new Date(localDate.toLocaleString("en-US", options));
        return istDate;
    });
    const [stockData1, setPutData] = useState([]);
    const [stockData2, setCallData] = useState([]);
    const [symbol1, setPutSymbol] = useState("");
    const [symbol2, setCallSymbol] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const authToken = getToken();
    const formattedDate = moment(selectedDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
    const selectedDateStr = moment(selectedDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
    const todayDateStr = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");

    const isSameDate = selectedDateStr === todayDateStr;

    const [PutMapData, setPutMapData] = useState([]);
    const [CallMapData, setCallMapData] = useState([]);
    const [selectedPutOption, setSelectedPutOption] = useState("");
    const [selectedCallOption, setSelectedCallOption] = useState("");

    const [CallToken, setCallToken] = useState(null);
    const [PutToken, setPutToken] = useState(null);

    const [TradeableCallToken, setTradeableCallToken] = useState(CallToken);
    const [TradeablePutToken, setTradeablePutToken] = useState(PutToken);
    const [traded, setTraded] = useState(false);

    const [PutoiThreshold, setPutoiThreshold] = useState(1);
    const [CalloiThreshold, setCalloiThreshold] = useState(1);

    const [macdData, setMacdData] = useState({});
    const [layoutMode, setLayoutMode] = useState("sideBySide");
    const [strategy, setStrategy] = useState(null);
    const [amount, setAmount] = useState(null);
    const [stopLoss, setStopLoss] = useState(null);
    const [target, setTarget] = useState(null);


    useEffect(() => {
        setTradeablePutToken(PutToken);
        setTradeableCallToken(CallToken);
    }, [PutToken, CallToken]);

    const fetchUserStrategyData = async () => {
        setLoading(true);
        try {
            const authToken = getToken();
            const response = await fetch(`${API}/app-user-strategies?filters[user][documentId][$eq]=${user.documentId}&filters[strategy][name][$eq]=Strategy_Default&populate=*`, {
                headers: { Authorization: `Bearer ${authToken}` },
            });
            const data = await response.json();
            setUserStrategies(data.data || []);
            setStrategy(data.data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (strategy) {
            setAmount(strategy.allocation || 0);
            setStopLoss(strategy.override_data?.stop_loss_percentage || 0);
            setTarget(strategy.override_data?.target_percentage || 0);
        }
    }, [strategy]);
    useEffect(() => {
        fetchUserStrategyData();
    }, []);
    // --------------------- WebSocket Hook & Functions --------------------- //
    const { isConnected, messageQueue, ws,wsRef } = useWebSocket(
        process.env.NODE_ENV === "production"
            ? "wss://zinvest.in/ws/"
            : "ws://localhost:8766"
        // : "wss://zinvest.in/ws/ "
        ,0
    );

    // const { isConnected, latestMessage, wsRef, } = useWebSocket(
    //     process.env.NODE_ENV === "production"
    //         ? "wss://zinvest.in/ws/"
    //         : "ws://localhost:8766"
    //     // : "wss://zinvest.in/ws/ "
    //     ,0,true
    // ); //If you want to update UI with the latest message on each incoming tick:



    // redux

    const dispatch = useDispatch();

    // --------------------- WebSocket Incoming Message Processing --------------------- //
    useEffect(() => {
        const interval = setInterval(() => {
            const queueLength = messageQueue.current.length;
            if (queueLength > 0) {
                console.log("messageQueue length", queueLength);

                const queue = [...messageQueue.current]; // snapshot
                messageQueue.current = []; // clear

                const hybridBuffer = {};
                const macdUpdates = {};

                queue.forEach(msg => {
                    // ✅ Tick handler
                    if (msg.type === "tick" && msg.token && msg.price && msg.timestamp) {
                        if (!hybridBuffer[msg.token]) hybridBuffer[msg.token] = [];

                        hybridBuffer[msg.token].push({
                            price: msg.price,
                            timestamp: msg.timestamp,
                            volume: msg.volume ?? null,
                            open_interest: msg.open_interest ?? 0,
                        });
                    }

                    // ✅ MACD histogram handler
                    if (msg.type === "macd_histogram" && msg.token && msg.data) {
                        macdUpdates[msg.token] = msg.data;
                    }
                });

                // Dispatch tick price updates to Redux
                if (Object.keys(hybridBuffer).length > 0) {
                    dispatch(updateMultipleTokenPrices(hybridBuffer));
                }

                // Update MACD state
                if (Object.keys(macdUpdates).length > 0) {
                    setMacdData(prev => ({
                        ...prev,
                        ...macdUpdates,
                    }));
                }
            }
        }, 200); // adjust interval as needed

        return () => clearInterval(interval);
    }, [dispatch]);
    const subscribeAll = () => {
        if (wsRef.current?.readyState === WebSocket.OPEN) {
            wsRef.current?.send(JSON.stringify({ subscribe_all: true }));
            console.log("✅ Subscribed to all tokens.");
        }
    };
    const subscribeMacd = (newToken) => {
        if (isConnected) {
            const macdSubscription = {
                subscribe: "macd_histogram",
                token: newToken,
                timeframes: [
                    { timeframe: "1min", short_window: 12, long_window: 26, signal_window: 9, shift: 1, num_rows: 7 },
                    { timeframe: "2min", short_window: 12, long_window: 26, signal_window: 9, shift: 1, num_rows: 7 },
                    { timeframe: "3min", short_window: 12, long_window: 26, signal_window: 9, shift: 1, num_rows: 7 },
                    { timeframe: "5min", short_window: 12, long_window: 26, signal_window: 9, shift: 1, num_rows: 14 },
                ],
            };
            wsRef.current?.send(JSON.stringify(macdSubscription));
            console.log("Subscribed to MACD histogram for token:", newToken, macdSubscription);
        }
    };
    const handleBuy = async (optionType) => {
        console.log("selected and todays date", selectedDateStr, todayDateStr)
        if (!isSameDate) {
            message.error("Please Select Todays Date for Placing Order");
            return;
        }

        if (!TradeableCallToken && optionType === "CE") {
            message.error("No Call Token ");
            return;
        }

        if (!TradeablePutToken && optionType === "PE") {
            message.error("No Put Token ");
            return;
        }

        setLoading(true);
        try {
            const authToken = getToken();
            const formData = {
                user_id: user.documentId,
                cash_allocation: amount,
                broker_name: strategy?.user_broker_account?.broker,
                broker_user_id: strategy?.user_broker_account?.broker_user_id,
                broker_api_key: strategy?.user_broker_account?.broker_api_key,
                indices_token: token,
                indices: "nifty",
                user_strategy_preference_id: strategy?.documentId,
                strategy_id: strategy?.strategy?.documentId,
                token: optionType === "PE" ? TradeablePutToken : TradeableCallToken,
            };
            const response = await OptionBuyToken(authToken, formData);

            console.log("Order Placed Successfully:", response.data);
            message.success("Order Placed Successfully!");

        } catch (error) {
            console.error("Order Placement Failed:", error);
            message.error("Failed to place order. Please try again.");
        } finally {
            setTraded(true);
            setLoading(false); // Reset loading state
        }
    };
    const handleSave = async () => {
        if (!amount || isNaN(amount)) {
            message.warning("Please enter a valid Amount.");
            return;
        }
        if (!stopLoss || isNaN(stopLoss)) {
            message.warning("Please enter a valid Stop Loss.");
            return;
        }
        if (!target || isNaN(target)) {
            message.warning("Please enter a valid Target.");
            return;
        }
        const payload = {
            allocation: Number(amount),
            override_data: {
                ...strategy.override_data,
                target_percentage: Number(target),
                stop_loss_percentage: Number(stopLoss),
            }
        };

        try {
            // Update with your actual API endpoint
            const authToken = getToken();
            const response = await fetch(`${API}/app-user-strategies/${strategy.documentId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken}` },
                body: JSON.stringify({ data: payload }),
            });
            console.log("response", response);

            message.success("Strategy Preferences saved successfully!");
        } catch (error) {
            console.error("Error saving preferences:", error);
            message.error("Failed to save preferences.");
        }
    };
    const handlePutSelectChange = ({ strike, token }) => {
        setPutToken(token);
        setSelectedPutOption(strike);
        fetchDataByToken(token, "PE");
    };
    const handleCallSelectChange = ({ strike, token }) => {
        setCallToken(token);
        setSelectedCallOption(strike);
        fetchDataByToken(token, "CE");
    };
    const handleDateChange = (selectedDate) => {
        const options = { timeZone: "Asia/Kolkata", hour12: false };
        const istDate = new Date(selectedDate.toLocaleString("en-US", options));
        setselectedDate(istDate);
    };

    // --------------------- Data Fetching & Polling --------------------- //
    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            setErrorMessage(null);
            try {
                const formattedDate = moment(selectedDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
                const response = await fetchOiAnalyz(authToken, formattedDate);
                console.log("API Response:", response);
                if (response?.data?.length >= 2) {
                    const [put, call] = response.data;
                    setPutData(put.data);
                    setCallData(call.data);
                    setPutSymbol(put.trading_symbol);
                    setCallSymbol(call.trading_symbol);
                    setPutToken(put.token);
                    setCallToken(call.token);
                } else {
                    setErrorMessage("No data available for the selected date.");
                    setPutData([]);
                    setCallData([]);
                    setPutSymbol("");
                    setCallSymbol("");
                    setPutToken(null);
                    setCallToken(null);
                }
            } catch (error) {
                console.error("Error fetching OI data:", error);
                setErrorMessage("Failed to fetch data. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
        fetchInitialData();
    }, [authToken, formattedDate]);

    useEffect(() => {
        const getCurrentTimeInIST = () => {
            const now = new Date();
            return new Date(now.getTime() + 5.5 * 60 * 60 * 1000);
        };

        const isWithinTradingHours = () => {
            const nowIST = getCurrentTimeInIST();
            const startIST = new Date(nowIST);
            startIST.setHours(9, 0, 0, 0);
            const endIST = new Date(nowIST);
            endIST.setHours(15, 30, 0, 0);
            return nowIST >= startIST && nowIST <= endIST;
        };

        if (selectedDate.toISOString().split("T")[0] === todayDate) {
            const interval = setInterval(() => {
                console.log("Polling latest OI data...");
                if (CallToken) {
                    fetchDataByToken(CallToken, "CE");
                }
                if (PutToken) {
                    fetchDataByToken(PutToken, "PE");
                }
            }, REFRESH_INTERVAL);
            return () => clearInterval(interval);
        }
    }, [selectedDate, CallToken, PutToken]);

    const fetchDataByToken = async (token, type) => {
        if (!token) return;
        setLoading(true);
        setErrorMessage(null);
        try {
            const formattedDate = moment(selectedDate).tz("Asia/Kolkata").format("YYYY-MM-DD");
            const response = await fetchOiAnalyz(authToken, formattedDate, token, type);
            console.log(`API Response for ${type}:`, response);
            if (response?.data?.length > 0) {
                const optionData = response?.data[0];
                if (type === "PE") {
                    setPutData(optionData?.data);
                    setPutSymbol(optionData?.trading_symbol);
                    setPutToken(optionData?.token);
                } else {
                    setCallData(optionData?.data);
                    setCallSymbol(optionData?.trading_symbol);
                    setCallToken(optionData?.token);
                }
            } else {
                setErrorMessage(`No ${type} data available for the selected option.`);
            }
        } catch (error) {
            console.error(`Error fetching ${type} OI data:`, error);
            setErrorMessage(`Failed to fetch ${type} data. Please try again later.`);
        } finally {
            setLoading(false);
        }
    };

    // --------------------- Automatic MACD Subscription --------------------- //
    useEffect(() => {
        const subscribeWhenReady = () => {
            if (isConnected) {
                subscribeMacd(Number(token));
            } else {
                setTimeout(subscribeWhenReady, 100);
            }
        };
        if (isConnected && token) {
            subscribeWhenReady();
        }
    }, [isConnected, token, ws]);
    // subscribe all
    useEffect(() => {
        const subscribeWhenReady = () => {
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                subscribeAll();
            }
        };
        if (isConnected) {
            subscribeWhenReady();
        }
    }, [isConnected, wsRef]);

    // --------------------- Option Maps --------------------- //
    useEffect(() => {
        fetchOptionMapsByTradeDate(authToken, formattedDate)
            .then((data) => {
                console.log("Fetched Option Map Data:", data.data);
                setPutMapData(data.peData);
                setCallMapData(data.ceData);
            })
            .catch((error) => console.error("API Error:", error));
    }, [selectedDate, authToken]);

    const getSeriesConfig = (stockData, symbol, oiThreshold) => {
        if (!symbol) return {};
        const formatData = (data, key) => {
            return data
                .map(({ datetime, [key]: value, trend }) => {
                    const timestampIST = new Date(datetime).getTime() / 1000;
                    const timestampUTC = timestampIST + 19800;
                    return {
                        time: timestampUTC,
                        value: parseFloat(value),
                        trend: trend,
                    };
                })
                .filter((item) => !isNaN(item.value));
        };
        const markers = stockData
            .filter(({ trend, oi_perc_change }) => trend !== 0 && Math.abs(oi_perc_change) >= oiThreshold)
            .map(({ trend, datetime }) => ({
                time: formatToUTCTimestamp(datetime),
                position: trend === 1 ? "belowBar" : "aboveBar",
                color: trend === 1 ? "#2196F3" : "#e91e63",
                shape: trend === 1 ? "arrowUp" : "arrowDown",
                text: `${trend === 1 ? "B" : "S"} @ ${formatValue(
                    stockData.find((d) => formatToUTCTimestamp(d.datetime) === formatToUTCTimestamp(datetime))?.ltp
                )}`,
            }));
        return {
            price: {
                type: "line",
                data: formatData(stockData, "ltp"),
                options: {
                    color: "#1f77b4",
                    lineWidth: 2,
                    priceScaleId: "left",
                    symbol: symbol,
                },
                markers: markers,
            },
            openInterest: {
                type: "line",
                data: formatData(stockData, "open_interest"),
                options: {
                    color: "#ff7f0e",
                    lineWidth: 2,
                    priceScaleId: "right",
                    symbol: symbol,
                },
            },
            oi_perc_change: {
                type: "histogram",
                data: stockData
                    .map(({ datetime, oi_perc_change }) => ({
                        time: new Date(datetime).getTime() / 1000 + 19800,
                        value: parseFloat(oi_perc_change),
                        color: oi_perc_change > 0 ? "green" : oi_perc_change < 0 ? "red" : "gray",
                    }))
                    .filter((item) => !isNaN(item.value)),
                options: {
                    priceScaleId: "left",
                    lineWidth: 1,
                    symbol: symbol,
                },
            },
        };
    };

    const seriesConfig1 = useMemo(() => {
        if (symbol1) {
            return getSeriesConfig(stockData1, symbol1, PutoiThreshold);
        }
        return {};
    }, [stockData1, symbol1]);

    const seriesConfig2 = useMemo(() => {
        if (symbol2) {
            return getSeriesConfig(stockData2, symbol2, CalloiThreshold);
        }
        return {};
    }, [stockData2, symbol2]);

    const pivotPoints = [
        { price: 300, label: "Pivot", color: "red" },
        { price: 200, label: "Resistance 1", color: "green" },
        { price: 100, label: "Support 1", color: "blue" },
    ];

    // --------------------- Render --------------------- //
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    alignItems: "center",
                    paddingTop: .2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                    }}
                >
                    <Box sx={{ width: "6%" }}>
                        <FormControl fullWidth>
                            <InputLabel id="pe-strike">Put Strike</InputLabel>
                            <Select
                                labelId="pe-strike-price"
                                value={PutToken || ""} // Token value directly
                                onChange={(e) => {
                                    const selectedToken = e.target.value;
                                    const selectedStrike = Object.keys(PutMapData).find(
                                        strike => PutMapData[strike] === selectedToken
                                    );
                                    handlePutSelectChange({ strike: selectedStrike, token: selectedToken });
                                }}
                                label="Select Put Option"
                                MenuProps={{
                                    PaperProps: { style: { maxHeight: 200, overflowY: "auto" } },
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select Strike</em>
                                </MenuItem>
                                {PutMapData &&
                                    Object.entries(PutMapData).map(([strike, token]) => (
                                        <MenuItem key={token} value={token}>
                                            {strike}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Box sx={{ width: "135px" }}>
                            <DatePicker
                                value={selectedDate}
                                onChange={handleDateChange}
                                components={{
                                    OpenPickerIcon: CalendarTodayIcon, // Custom icon if needed
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        InputProps={{
                                            ...params.InputProps,
                                            disableUnderline: true,
                                            endAdornment: params.InputProps.endAdornment,
                                            sx: { padding: 0, width: "100%" },
                                        }}
                                        sx={{ width: "100%", padding: 0, minWidth: "36px" }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                    {
                        // Token:{latestMessage?.token == "26000" && latestMessage?.token} 
                        // <Typography>Nifty : {latestMessage?.token == "26000" && latestMessage?.price}</Typography>

                    }
                    <OptionBuyingTool
                        setAmount={setAmount}
                        setTarget={setTarget}
                        setStopLoss={setStopLoss}
                        amount={amount}
                        stopLoss={stopLoss}
                        target={target}
                        handleBuy={handleBuy}
                        // handleSquareOff={handleSquareOff}
                        handleSave={handleSave}
                        strategy={strategy}
                        traded={traded}
                        setTraded={setTraded}
                    />
                    {/* ------------------------------------------ */}
                    <Box>
                        <IconButton
                            onClick={() =>
                                setLayoutMode(layoutMode === "sideBySide" ? "stacked" : "sideBySide")
                            }
                        >
                            {layoutMode === "sideBySide" ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            position: "fixed",
                            // top: 10,
                            right: 100,
                            display: "flex",
                            alignItems: "center",
                            // gap: 1,
                            zIndex: 9999,
                        }}
                    >
                        <Box
                            sx={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: isConnected ? "green" : "red",
                            }}
                        />
                    </Box>
                    <Box sx={{ width: "6%" }}>
                        <FormControl fullWidth>
                            <InputLabel id="ce-strike">Call Strike</InputLabel>
                            <Select
                                labelId="ce-strike-price"
                                value={CallToken || ""}
                                onChange={(e) => {
                                    const selectedToken = e.target.value;
                                    const selectedStrike = Object.keys(CallMapData).find(
                                        strike => CallMapData[strike] === selectedToken
                                    );
                                    handleCallSelectChange({ strike: selectedStrike, token: selectedToken });
                                }}
                                label="Select Call Option"
                                MenuProps={{
                                    PaperProps: { style: { maxHeight: 200, overflowY: "auto" } },
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select Strike</em>
                                </MenuItem>
                                {CallMapData &&
                                    Object.entries(CallMapData).map(([strike, token]) => (
                                        <MenuItem key={token} value={token}>
                                            {strike}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
                {errorMessage && (
                    <Box sx={{ color: "red", textAlign: "center", mt: 1 }}>
                        {errorMessage}
                    </Box>
                )}
                {loading && (
                    <Box sx={{ position: "absolute", top: 10, right: 10 }}>
                        <CircularProgress size={24} />
                    </Box>
                )}
            </Box>
            <Grid container spacing={2} sx={{ mb: 2 }} paddingTop={.5}>
                <Grid item xs={12} md={layoutMode === "sideBySide" ? 6 : 12}>
                    <Box sx={{ width: "100%", height: "350px" }}>
                        {symbol1 && stockData1.length > 0 && (
                            <Box sx={{ width: "100%", height: "100%" }}>
                                <MultiLineOIChart
                                    seriesConfig={seriesConfig1}
                                    pivotPoints={pivotPoints}
                                    width="100%"
                                    height={400}
                                    symbol={symbol1}
                                />
                            </Box>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={12} md={layoutMode === "sideBySide" ? 6 : 12}>
                    <Box sx={{ width: "100%", height: "350px" }}>
                        {symbol2 && stockData2.length > 0 && (
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "100%"
                                }}
                            >
                                <MultiLineOIChart
                                    seriesConfig={seriesConfig2}
                                    pivotPoints={pivotPoints}
                                    width="100%"
                                    height={400}
                                    symbol={symbol2}
                                />
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>
            <Grid paddingTop={4}>
                <Box sx={{ mt: 2 }}>
                    {macdData[token] ? (
                        <DynamicMACDCharts macdData={macdData[token]} />
                    ) : (
                        <Typography align="center" variant="body2">
                            No MACD data available.
                        </Typography>
                    )}
                </Box>
            </Grid>
        </LocalizationProvider>
    );
};

export default TraderPageTV;

